import { render, staticRenderFns } from "./FormSectionConfig.vue?vue&type=template&id=1b6af93b&scoped=true"
import script from "./FormSectionConfig.vue?vue&type=script&lang=js"
export * from "./FormSectionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6af93b",
  null
  
)

export default component.exports